import React from 'react'
import {Route, Switch, useHistory, useLocation} from 'react-router-dom';
import {ExpandableSidebar, NavDivider, Navigation, NotFound, Wrapper} from "retro";
import PasswordChange from './Password'
import Updates from './Updates'
import FileIcon from "@atlaskit/icon/glyph/settings";
import TwoFactorAuthentication from './TwoFactorAuthentication'

function Settings() {
	const History = useHistory();
	const location = useLocation();
	const saas = window.location.origin.includes('cockpit.dice.tech');
	return (
		<div className="flex h-100h w-100">
			<ExpandableSidebar items={[
				{
					title: "Actions",
					actions: [

						{
							title: 'Change Password',
							icon: (<FileIcon size="small"/>),
							active: location.pathname === '/app/settings',
							onClick: () => {
								History.push('/app/settings')
							},
						},
						{
							title: 'Version Updates',
							icon: (<FileIcon size="small"/>),
							active: location.pathname === '/app/settings/updates',
							onClick: () => {
								History.push('/app/settings/updates')
							},
						},
						...saas ? [{
							title: 'Enable 2FA',
							icon: (<FileIcon size="small"/>),
							active: location.pathname === '/app/settings/2fa',
							onClick: () => {
								History.push('/app/settings/2fa')
							},
						}] : [],
					]
				}
			]}/>
			<Wrapper>
				<Navigation title='Account Settings' chips={['Settings']}/>
				<NavDivider/>
				<Switch>
					<Route path="/app/settings/updates" exact component={Updates}/>
					<Route path="/app/settings" exact component={PasswordChange}/>
					<Route path="/app/settings/2fa" exact component={TwoFactorAuthentication}/>
					<NotFound/>
				</Switch>
			</Wrapper>
		</div>
	);
}

export default Settings;
